import { library } from "@fortawesome/fontawesome-svg-core";

import {
	faTelegram
} from '@fortawesome/free-brands-svg-icons'
import {
	faUser,
	faSignInAlt,
	faCog
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
	faTelegram,
	faUser,
	faSignInAlt,
	faCog
);

export { FontAwesomeIcon };
